export default __webpack_public_path__ + "assets/images/maskCombo-27fc7e3128ffddc58dc42bfa4228ee7b.png";